import React, { useMemo } from "react";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Box from "@mui/material/Box";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Collapse from "@mui/material/Collapse";
import IconButton from "@mui/material/IconButton";
import PersonIcon from "@mui/icons-material/Person";
import DensityMediumIcon from "@mui/icons-material/DensityMedium";
import Modal from "@mui/material/Modal";
import { brandConfig, brandLogoSrc } from "@config/brand.config";
import useDictionary from "@ui/hooks/useDictionary";
import SettingsContainer from "@ui/features/Settings/Settings.container";
import StatisticsContainer from "@ui/features/Statistics/Statistics.container";
import LangSelectorContainer from "../Lang-selector/Lang-selector.container";
import TechSupportContainer from "../Tech-support/Tech-support.container";
import LoginContainer from "../LoginOldDevices/LoginOldDevices.container";
import AddOldDeviceContainer from "../Add-old-devices/Add-old-devices.container";
import { Menu } from "@ui/components/Menu/menu";
import { IMenuItem } from "@ui/components/Menu/IMenuItem";
import { IProps } from "./IProps";
import ExistOldLoginContainer from "../Exist-old-login/Exist-old-login.container";

const Component: React.FC<IProps> = ({
    userType,
    importOldVisible,
    page,
    desktopMode,
    statisticsVisible,
    mainMenuVisible,
    settingsVisible,
    techSupportVisible,
    loginOldDevicesVisible,
    AddOldDeviceCloseVisible,
    ExistOldLoginVisible,
    modeSwitch,
    lang,
    isDevices,
    onPrivacyPolicy,
    onLogOut,
    onTechSupportClose,
    onTechSupportOpen,
    onSettingsOpen,
    onSettingsClose,
    onStatisticsOpen,
    onStatisticsClose,
    onMainMenuBtnClick,
    onPageChange,
    onKeyDown,
    onTabClick,
    onLoginOldDevicesOpen,
    onLoginOldDevicesClose,
    onAddOldDeviceClose,
    onExistOldLoginClose,
}: IProps) => {
    const getWord = useDictionary();
    const timeout = modeSwitch ? 0 : undefined;
    const collapse = desktopMode || mainMenuVisible;
    const orientation = desktopMode ? "horizontal" : "vertical";
    const subusersTab = useMemo(() => {
        if (userType === "superuser" || userType === "regular") {
            return (
                <Tab
                    className="header__btn"
                    value="subusers"
                    href="/subusers"
                    label={getWord("subusers")}
                    onClick={onTabClick}
                />
            );
        }
    }, [userType, lang]);

    const userMenuMap = {
        aboutAccount: onStatisticsOpen,
        importOldDevices: onLoginOldDevicesOpen, // ЭТА КНОПКА ВЫКЛЮЧАЕТ в верхнем правом меню кнопку импортирования из старого аккаунта устройств
        techSupport: onTechSupportOpen,
        settings: onSettingsOpen,
        privacyPolicy: onPrivacyPolicy,
        logOut: onLogOut,
    };
    const userMenuItems: IMenuItem[] = useMemo(
        () =>
            Object.keys(userMenuMap).map((item) => ({
                id: item,
                text: item,
                onClick: userMenuMap[item as keyof typeof userMenuMap],
                onKeyDown,
            })),
        [onStatisticsOpen, onSettingsOpen, onLogOut]
    );

    return (
        <>
            <AppBar className="header__wrap" position="relative">
                <Toolbar className="header" variant="dense">
                    <IconButton
                        className="header__main-menu-btn"
                        onClick={onMainMenuBtnClick}
                    >
                        <DensityMediumIcon />
                    </IconButton>
                    <Box
                        className="header__logo"
                        component="img"
                        src={brandLogoSrc(brandConfig.logo.header, lang)}
                        width={brandConfig.logo.header.width}
                        height={brandConfig.logo.header.height}
                    />
                    <Collapse
                        classes={{
                            root: "header__main-menu-wrap",
                            wrapperInner: "header__main-menu",
                        }}
                        in={collapse}
                        timeout={timeout}
                    >
                        <Tabs
                            classes={{
                                root: "header__main-menu-tabs",
                                indicator: "header__main-menu-indicator",
                            }}
                            component="nav"
                            TabIndicatorProps={{
                                sx: { transition: "none" },
                            }}
                            value={page}
                            orientation={orientation}
                            onChange={onPageChange}
                        >
                            <Tab
                                className="header__btn"
                                value=""
                                href="/"
                                label={getWord("lastLocation")}
                                onClick={onTabClick}
                            />
                            <Tab
                                className="header__btn"
                                value="history"
                                href="/history"
                                label={getWord("locationHistory")}
                                onClick={onTabClick}
                            />
                            <Tab
                                className="header__btn"
                                value="reports"
                                href="/reports"
                                label={getWord("reports")}
                                onClick={onTabClick}
                            />
                            {/* {isDevices && (
                                <Tab
                                    className="header__btn"
                                    value="statistics"
                                    href="/statistics"
                                    label={getWord('statistics')}
                                    onClick={onTabClick}
                                />
                            )} */}

                            {subusersTab}
                            {userType === "superuser" && (
                                <Tab
                                    className="header__btn"
                                    value="support"
                                    href="/support"
                                    label={getWord("techSupport")}
                                    onClick={onTabClick}
                                />
                            )}
                            {userType === "superuser" && (<Tab
                                className="header__btn"
                                value="geozones"
                                href="/geozones"
                                label={getWord("geozones")}
                                onClick={onTabClick}
                            />)}
                        </Tabs>
                    </Collapse>
                    <Box className="header__menu-list">
                        <Box className="header__menu-wrap">
                            <LangSelectorContainer />
                        </Box>
                        <Box className="header__menu-wrap">
                            <Menu
                                label="user-menu"
                                button={<PersonIcon />}
                                items={userMenuItems}
                            />
                        </Box>
                    </Box>
                </Toolbar>
            </AppBar>
            <Modal open={techSupportVisible} onClose={onTechSupportClose}>
                <TechSupportContainer onClose={onTechSupportClose} />
            </Modal>
            <Modal open={settingsVisible} onClose={onSettingsClose}>
                <SettingsContainer onClose={onSettingsClose} />
            </Modal>
            <Modal open={statisticsVisible} onClose={onStatisticsClose}>
                <StatisticsContainer onClose={onStatisticsClose} />
            </Modal>
            <Modal
                open={loginOldDevicesVisible}
                onClose={onLoginOldDevicesClose}
            >
                <LoginContainer onClose={onLoginOldDevicesClose} />
            </Modal>
            <Modal
                open={AddOldDeviceCloseVisible}
                onClose={onAddOldDeviceClose}
            >
                <AddOldDeviceContainer onClose={onAddOldDeviceClose} />
            </Modal>
            <Modal open={ExistOldLoginVisible} onClose={onExistOldLoginClose}>
                <ExistOldLoginContainer onClose={onExistOldLoginClose} />
            </Modal>
        </>
    );
};

const HeaderComponent = React.memo(Component);

export default HeaderComponent;
